import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';
import { TableContainer, Table, TableBody, Grid } from '@mui/material';
import { DateFormat } from '../../Format/DateTimeFormat';
import { ExpandableContainer } from '../../ExpandableContainer/ExpandableContainer';
import { ActionCardHeader } from '../../Customer/ActionCardHeader';
import { WeightedTableRow } from '../../Table/WeightedTableRow';

type DefaultActionCardProps = {
  action: {
    status: string;
    reason: string;
    type: string;
    createdDate: string;
  };
  items: {
    header: string;
    value: ReactNode;
  }[];
  headerProps: object;
  children: ReactNode;
};

export const DefaultActionCard = ({ action, items, headerProps, children }: DefaultActionCardProps) => {
  const { t } = useTranslation();
  const type = action.type;
  const reason = action.reason;
  const defaultItems = [
    { header: t('components.cards.defaultSessionAction.createdDate'), value: <DateFormat date={action.createdDate} /> },
    { header: t('enums.sessionActionReason.name'), value: t(`enums.sessionActionReason.values.${reason}`, reason) },
  ];

  return (
    <ExpandableContainer
      header={
        <ActionCardHeader
          status={action.status}
          headerText={type ? t(`enums.sessionActionType.${type}`, type) : '?'}
          {...headerProps}
        />
      }
      sx={{ mb: 2 }}
    >
      <TableContainer>
        <Table>
          <TableBody>
            <Grid container>
              <Grid item>
                {map(
                  defaultItems,
                  item =>
                    item && (
                      <WeightedTableRow
                        key={`${item.header}_${item.value}`}
                        header={item.header}
                        value={item.value ? item.value : '-'}
                      />
                    ),
                )}
              </Grid>
              <Grid item>
                {map(
                  items,
                  item =>
                    item && (
                      <WeightedTableRow
                        key={`${item.header}_${item.value || '-'}`}
                        header={item.header}
                        value={item.value ? item.value : '-'}
                      />
                    ),
                )}
              </Grid>
            </Grid>
            {children}
          </TableBody>
        </Table>
      </TableContainer>
    </ExpandableContainer>
  );
};
